import React from 'react';
import { Arrow } from 'ui/Components';

/**
 * render arrow style
 * @param {boolean} visible - element from state
 * @returns {object} style
 */
const renderArrowStyle = visible => {
  const style = visible ? <Arrow facing="down" /> : <Arrow facing="right" />;
  return style;
};

export { renderArrowStyle };
